var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 60,
    viewBox: "0 0 233 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_41_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0738 51.9999H62.1771L43.9827 39.5486L27.0738 51.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1311 29.4196L2 18.1938L20.6451 50.3879L29.1311 29.4196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4764 29.4196L67.9624 50.3879L86.6075 18.1938L59.4764 29.4196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1172 20.42L22.5728 7.80688V24.3872L30.127 26.904L33.1172 20.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9882 24.3872V7.80688L55.445 20.42L58.434 26.904L65.9882 24.3872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1754 36.1297L65.9694 52L44.1754 0L22.5728 52L44.1754 36.1297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.668 12C109.908 12 110.981 12.2067 111.888 12.62C112.808 13.0333 113.514 13.62 114.008 14.38C114.501 15.14 114.748 16.04 114.748 17.08C114.748 18.1067 114.501 19.0067 114.008 19.78C113.514 20.54 112.808 21.1267 111.888 21.54C110.981 21.94 109.908 22.14 108.668 22.14H105.848V26H102.608V12H108.668ZM108.488 19.5C109.461 19.5 110.201 19.2933 110.708 18.88C111.214 18.4533 111.468 17.8533 111.468 17.08C111.468 16.2933 111.214 15.6933 110.708 15.28C110.201 14.8533 109.461 14.64 108.488 14.64H105.848V19.5H108.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.901 23.4V26H119.061V12H129.641V14.6H122.281V17.64H128.781V20.16H122.281V23.4H129.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.699 23H137.199L135.959 26H132.639L138.879 12H142.079L148.339 26H144.939L143.699 23ZM142.679 20.54L140.459 15.18L138.239 20.54H142.679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.891 20.5L155.011 22.46V26H151.791V12H155.011V18.54L161.211 12H164.811L159.011 18.24L165.151 26H161.371L156.891 20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.596 12H174.956C176.476 12 177.816 12.2933 178.976 12.88C180.149 13.4533 181.056 14.2667 181.696 15.32C182.349 16.3733 182.676 17.6 182.676 19C182.676 20.4 182.349 21.6267 181.696 22.68C181.056 23.7333 180.149 24.5533 178.976 25.14C177.816 25.7133 176.476 26 174.956 26H168.596V12ZM174.796 23.34C176.196 23.34 177.309 22.9533 178.136 22.18C178.976 21.3933 179.396 20.3333 179.396 19C179.396 17.6667 178.976 16.6133 178.136 15.84C177.309 15.0533 176.196 14.66 174.796 14.66H171.836V23.34H174.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.959 23.4V26H187.119V12H197.699V14.6H190.339V17.64H196.839V20.16H190.339V23.4H197.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.777 14.6V18.3H212.257V20.9H205.777V26H202.537V12H213.117V14.6H205.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.311 12H220.551V26H217.311V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.608 38.12H104.088V50.84H111.928V52.12H102.608V38.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.231 52.24C120.845 52.24 119.585 51.9333 118.451 51.32C117.331 50.6933 116.451 49.84 115.811 48.76C115.185 47.68 114.871 46.4667 114.871 45.12C114.871 43.7733 115.185 42.56 115.811 41.48C116.451 40.4 117.331 39.5533 118.451 38.94C119.585 38.3133 120.845 38 122.231 38C123.618 38 124.865 38.3067 125.971 38.92C127.091 39.5333 127.971 40.3867 128.611 41.48C129.251 42.56 129.571 43.7733 129.571 45.12C129.571 46.4667 129.251 47.6867 128.611 48.78C127.971 49.86 127.091 50.7067 125.971 51.32C124.865 51.9333 123.618 52.24 122.231 52.24ZM122.231 50.92C123.338 50.92 124.338 50.6733 125.231 50.18C126.125 49.6733 126.825 48.98 127.331 48.1C127.838 47.2067 128.091 46.2133 128.091 45.12C128.091 44.0267 127.838 43.04 127.331 42.16C126.825 41.2667 126.125 40.5733 125.231 40.08C124.338 39.5733 123.338 39.32 122.231 39.32C121.125 39.32 120.118 39.5733 119.211 40.08C118.318 40.5733 117.611 41.2667 117.091 42.16C116.585 43.04 116.331 44.0267 116.331 45.12C116.331 46.2133 116.585 47.2067 117.091 48.1C117.611 48.98 118.318 49.6733 119.211 50.18C120.118 50.6733 121.125 50.92 122.231 50.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.413 39.4H132.493V38.12H143.813V39.4H138.893V52.12H137.413V39.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.093 39.4H146.173V38.12H157.493V39.4H152.573V52.12H151.093V39.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.758 50.84V52.12H161.858V38.12H171.458V39.4H163.338V44.38H170.578V45.64H163.338V50.84H171.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.796 52.12L183.596 47.62C183.236 47.66 182.863 47.68 182.476 47.68H178.716V52.12H177.236V38.12H182.476C184.263 38.12 185.663 38.5467 186.676 39.4C187.69 40.2533 188.196 41.4267 188.196 42.92C188.196 44.0133 187.916 44.94 187.356 45.7C186.81 46.4467 186.023 46.9867 184.996 47.32L188.416 52.12H186.796ZM182.436 46.42C183.823 46.42 184.883 46.1133 185.616 45.5C186.35 44.8867 186.716 44.0267 186.716 42.92C186.716 41.7867 186.35 40.92 185.616 40.32C184.883 39.7067 183.823 39.4 182.436 39.4H178.716V46.42H182.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.294 47.28V52.12H196.834V47.28L191.234 38.12H192.814L197.614 45.98L202.414 38.12H203.894L198.294 47.28Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_41_53",
    x: 0,
    y: 0,
    width: 235,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.223529 0 0 0 0 0.647059 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_41_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_41_53",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.0bc3418015d0e0a426ecee555ad0b173.svg";
export { ForwardRef as ReactComponent };